import React, { createContext, useState } from "react";

export const AmeyoContext = createContext();

export const useAmeyoModal = () => {
  const [minimized, setMinimized] = useState(false);
  const [showAmeyoPanel, setShowAmeyoPanel] = useState(false);

  const showDialog = () => {
    setMinimized(false);
  };

  const closeDialog = () => {
    setMinimized(true);
  };

  const showPanel = () => {
    // console.log('worked');
    setShowAmeyoPanel(true);
  };

  const closePanel = () => {
    setShowAmeyoPanel(false);
  };


  return {
    minimized,
    showDialog,
    closeDialog,
    showPanel,
    closePanel,
    showAmeyoPanel,
  };
};

export const AmeyoProvider = ({ children }) => {
  const ameyo = useAmeyoModal();
  return (
    <AmeyoContext.Provider value={ameyo}>{children}</AmeyoContext.Provider>
  );
};
